<cmps-dialog
    class="cmps-cdk-p-0 cmps-cdk-pos-relative cmps-cdk-overflow-hidden"
    [class.cmps-cdk-h-100p]="!_service.state?.minimized"
>
    <div
        class="cmps-ca-analysis-dialog--dialog cmps-cdk-pos-absolute cmps-cdk-pos-top-0 cmps-cdk-pos-right-0 cmps-cdk-pos-bottom-0 cmps-cdk-pos-left-0 cmps-cdk-z-index-1"
        [style.background-image]="
            'url(' +
            _service.state?.meetingRequestContext?.evaluationBackgroundImage +
            ')'
        "
    >
        <div
            class="cmps-cdk-pos-absolute cmps-cdk-pos-top-0 cmps-cdk-pos-right-0 cmps-cdk-pos-bottom-0 cmps-cdk-pos-left-0"
        ></div>
    </div>
    <cmps-dialog-header
        class="cmps-ca-analysis-dialog--header cmps-cdk-px-1 cmps-cdk-py-0dot5 cmps-cdk-z-index-2"
    >
        <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
            <div>
                <img
                    class="cmps-ca-analysis-dialog--icai"
                    src="assets/intelligent-coach-assist-icon.svg"
                    alt=""
                    aria-hidden="true"
                />
            </div>
            <div
                class="cmps-cdk-flex-grow-1 cmps-cdk-font-size-20p cmps-cdk-font-bold cmps-cdk-ml-1"
                *ngIf="!_service.state?.minimized"
            >
                <span>{{
                    _i18n.__INTELLIGENT_COACH_ASSIST_GPS | translate
                }}</span>
                <cmps-icon
                    class="d-inline-block cmps-cdk-ml-0dot5"
                    [class.cmps-cdk-fill-grey-400]="
                        _service.state.transcriptStatus !== 'green'
                    "
                    [class.cmps-cdk-fill-green-100]="
                        _service.state.transcriptStatus === 'green'
                    "
                    svgIcon="circle"
                ></cmps-icon>
            </div>
            <div
                class="cmps-cdk-flex-grow-1 cmps-cdk-ml-1"
                *ngIf="_service.state?.minimized"
            >
                <cmps-ca-score-section
                    [hideInfo]="true"
                    [scorePercent]="_service.state?.result?.scorePercent"
                ></cmps-ca-score-section>
            </div>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="
                        _service.state?.minimized
                            ? (_i18n.__MAXIMIZE | translate)
                            : (_i18n.__MINIMIZE | translate)
                    "
                    trigger="hover"
                    (click)="_onMinMaxClick()"
                >
                    <cmps-icon
                        [svgIcon]="_service.state?.minimized ? 'plus' : 'minus'"
                    ></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                    trigger="hover"
                    (click)="_onCloseClick()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body
        class="cmps-ca-analysis-dialog--body cmps-cdk-px-1 cmps-cdk-flex-grow-1 cmps-cdk-z-index-2"
        *ngIf="!_service.state?.minimized"
    >
        <div class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-h-100p">
            <div class="cmps-cdk-my-0dot5">
                <cmps-ca-score-section
                    [scorePercent]="_service.state?.result?.scorePercent"
                ></cmps-ca-score-section>
            </div>
            <div
                class="cmps-cdk-flex-grow-1 cmps-cdk-flex-basis-0 cmps-cdk-mb-0dot5 cmps-cdk-overflow-y-auto"
            >
                <cmps-ca-live-evaluation
                    [caResult]="_service.state?.result"
                ></cmps-ca-live-evaluation>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>

<ng-template #hudBtnTpl>
    <div>
        <button
            class="cmps-icon-button--no-bg"
            cmpsIconButton
            [cmpsTooltipTrigger]="
                _i18n.__INTELLIGENT_COACH_ASSIST_GPS | translate
            "
            placement="bottom-center"
            (click)="_service.isOpen ? _service.close() : _service.open()"
        >
            <cmps-icon svgIcon="post-outline"></cmps-icon>
        </button>
    </div>
</ng-template>
